var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserYourTeam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 24.9987,
    r: 16.6667,
    fill: "#DC143C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.75 91.6667C61.8753 91.6667 58.438 91.6667 56.3023 89.531C54.1666 87.3953 54.1666 83.958 54.1666 77.0833C54.1666 70.2087 54.1666 66.7714 56.3023 64.6357C58.438 62.5 61.8753 62.5 68.75 62.5C75.6246 62.5 79.0619 62.5 81.1976 64.6357C83.3333 66.7714 83.3333 70.2087 83.3333 77.0833C83.3333 83.958 83.3333 87.3953 81.1976 89.531C79.0619 91.6667 75.6246 91.6667 68.75 91.6667ZM76.9501 73.9409C77.8993 72.9917 77.8993 71.4528 76.9501 70.5036C76.0009 69.5544 74.462 69.5544 73.5128 70.5036L65.5092 78.5071L63.9871 76.985C63.0379 76.0358 61.499 76.0358 60.5498 76.985C59.6006 77.9342 59.6006 79.4732 60.5498 80.4224L63.7906 83.6631C64.7397 84.6123 66.2787 84.6123 67.2279 83.6631L76.9501 73.9409Z",
    fill: "#DC143C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2281 56.2821C60.0193 54.9356 55.1666 54.168 50 54.168C33.8917 54.168 20.8334 61.6299 20.8334 70.8346C20.8334 79.7536 33.0935 87.0363 48.5089 87.4799C48.3958 86.9537 48.3084 86.4313 48.2395 85.9183C47.9158 83.5111 47.9163 80.5701 47.9167 77.4428V76.7264C47.9163 73.5991 47.9158 70.658 48.2395 68.2508C48.5996 65.5722 49.4604 62.6402 51.883 60.2175C54.3057 57.7949 57.2377 56.9341 59.9164 56.5739C61.2162 56.3992 62.6717 56.3189 64.2281 56.2821Z",
    fill: "#DC143C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserYourTeam);
export default __webpack_public_path__ + "static/media/user-your-team.65d7f27c19fd932d4d0ef9c3df491e30.svg";
export { ForwardRef as ReactComponent };